import React from 'react';

import { AccountSettingsHeader } from '../components/AccountSettingsHeader';
import { AccountSettingsContent } from '../components/AccountSettingsContent';

import { AccountSettingsView } from './context';

import { ShopScreen } from 'features/shop-base/ShopScreen';
import { withAuth } from 'features/auth/components/withAuth';
import useFeatureFlags, { FeatureFlagTypes } from 'common/hooks/useFeatureFlags';
import { LoadingScreen } from 'components/loading-screen/LoadingScreen';
import { Routes } from 'routes';
import { Redirect, useRouteMatch } from 'react-router-dom';

export const AccountSettingsScreen = withAuth()(() => {
    const { isEnabled, loadingFlags } = useFeatureFlags();
    const enableUnifiedCoordinatorDashboard = isEnabled(
        FeatureFlagTypes.enable_unified_coordinator_dashboard
    );

    const routeMatchWithCoordinatorDashboard = useRouteMatch(
        Routes.ShopAccountSettingsCoordinatorTab
    );

    if (loadingFlags) {
        return <LoadingScreen />;
    }

    if (enableUnifiedCoordinatorDashboard && routeMatchWithCoordinatorDashboard) {
        return <Redirect to={Routes.CoordinatorDashboardHome} />;
    }

    return (
        <ShopScreen>
            <AccountSettingsView>
                <AccountSettingsHeader />
                <AccountSettingsContent />
            </AccountSettingsView>
        </ShopScreen>
    );
});
